
import React, { useEffect, useState } from "react";
import { 
    Box, CircularProgress, Grid, IconButton, InputAdornment, 
    MenuItem, Stack, Switch, Typography, useTheme, Button, Modal 
} from "@mui/material";
import { 
    addNewGroupBooking, getSubAgentsForDropdown, listAllHotelAgents, listAllMealPlans, resetAllHotelAgents, resetAllMealPlansData 
} from "../../../store/actions";
import { Add, ArrowBack, Build, Done, Email, Money, Person, Person2, Phone } from "@mui/icons-material";
import { useSelector, useDispatch } from "react-redux";
import { CssTextField } from "../../../components/TextField";
import { tokens } from "../../../theme";
import { Formik } from "formik";
import { toast } from "react-toastify";
import AddNewAgentModalContent from "../../agents/addNewAgentModalContent";
import AddNewSubAgentModalContent from "../../agents/addNewSubAgentModalContent";
import Header from "../../../components/Header";
import titles from "../../../data/nameTitles";
import * as yup from "yup";

const AddNewBooking = ({ setPage, checkingdata, selectedRooms, navigate }) => {
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const dispatch = useDispatch();
    const [status, setStatus] = useState("confirmed");
    // const [mealPlan, setMealPlan] = useState("no_preference");
    const [agent, setAgent] = useState("no_preference");
    const [subAgent, setSubAgent] = useState("no_preference");
    const [agentEnabled, setAgentEnabled] = useState(false);
    const [addAgentModal, setAddAgentModal] = useState(false);
    const [addSubAgentModal, setAddSubAgentModal] = useState(false);
    // const rateErrorMsg = `Value should not exceed total rate of selected room (${selectedRooms[0]?.rate})`
    
    const { isLoading, agentsList, subAgentsList, availableRoomsData } = useSelector(
        ({
            loading,
            agents: {
                agents: { list },
                subAgentsList,
            },
            admin: {
                availableRooms,
            },
            // booking: { mealPlans }
        }) => ({
            isLoading: loading,
            agentsList: list,
            subAgentsList,
            availableRoomsData: availableRooms,
            // mealPlans
        })
    );
    let filtered = availableRoomsData?.list[0]?.data.filter((e) => selectedRooms.map((j) => j.room_id).includes(e?._id) )
    let rackRate = filtered.reduce((k,l) => k+l.rate, 0);

    useEffect(() => {
        dispatch(resetAllHotelAgents());
        dispatch(listAllHotelAgents({isForDropdown: true}));
        dispatch(resetAllMealPlansData());
        dispatch(listAllMealPlans({ 
            roomtypeId: selectedRooms[0]?.roomtype_id?._id ,
            isForDropdown: true, 
        }));
        // eslint-disable-next-line
    },[])

    const handleAgentChange = async (e) => {
        setAgent(e.target.value)
        setSubAgent("no_preference")
    }
    const fetchSubAgents = async () => {
        if(agent !== "no_preference"){
            dispatch(getSubAgentsForDropdown({ id: agent }));
        }
    }
    useEffect(() => {
        fetchSubAgents()
    // eslint-disable-next-line
    },[agent])

    const handleFormSubmit = async (values) => {
        if(agentEnabled && agent === "no_preference"){
            return toast.error("Please select an agent");
        }
        else if(agentEnabled && agent !== "no_preference"){
            if(subAgent === "no_preference"){
                return toast.error("Please select a sub agent");
            } else {
                let filtered = subAgentsList?.filter((e) => e._id === subAgent)
                if(!filtered?.length){
                    return toast.error("Please select a valid sub agent");
                }
            }
        }

        if(!values.customPrice) {
            let filtered = availableRoomsData?.list[0].data.filter((e) => selectedRooms.map((j) => j.room_id).includes(e?._id) )

            let totalAmount = filtered.reduce((k,l) => k+l.rate, 0);
            if(values.paidAmount > totalAmount) {
                return toast.error("Paid amount cannot be higher than total rooms amount");
            }
        }

        // let roomsData = [{
        //     // ...checkingdata.rooms[0],
        //     room_number: 1,
        //     room_id: selectedRooms[0]?.room_id,
        //     no_of_adults: checkingdata.rooms[0]?.no_of_adults,
        //     no_of_childs: checkingdata.rooms[0]?.no_of_childs,
        // }]
        let data = {
            ...values,
            ...checkingdata,
            numOfAdults: checkingdata.rooms[0]?.no_of_adults,
            numOfChilds: checkingdata.rooms[0]?.no_of_childs,
            guestName: values.name,
            guestEmail: values.email,
            status: status,
            // mealPlanId: mealPlan === "no_preference" ? "" : mealPlan,
            agentId: agent === "no_preference" ? "" : agent,
            subAgentId: subAgent === "no_preference" ? "" : subAgent,
            rooms: selectedRooms,
        };
        if (data.paidAmount === ""){
            delete data.paidAmount;
        }
        if (data.customPrice === ""){
            delete data.customPrice;
        }
        console.log(data);
        let result = await dispatch(addNewGroupBooking(data));
        if (result) {
            navigate("/bookings");
        }
    };
    const initialValues = {
        title: "Mr",
        name: "",
        email: "",
        paidAmount: "",
        customPrice: "",
        preference: "",
        billingInstruction: "",
        // paymentMethod: "",
        guestMobile: "",
        guestAddress: "",
        remarks: "",
    };
    const checkoutSchema = yup.object().shape({
        name: yup.string().required("Required"),
        email: yup.string().email("Invalid email"),
        // paidAmount: yup.number().min(0).max(selectedRooms[0]?.rate, rateErrorMsg),
    });

    return (
        <Box 
            width="100%"
            p={2}
            backgroundColor={colors.primary[400]}
        >
            <Grid container>
                <Grid item lg={12} xs={12}>
                    <Stack
                        direction="row"
                        alignItems="flex-end"
                        spacing={1}
                        mb="10px"
                    >
                        <Box title="go back" height={"40px"}>
                            <IconButton type="button" onClick={() => setPage(2)}>
                                <ArrowBack />
                            </IconButton>
                        </Box>
                        <Header title="ENTER BOOKING DETAILS" titleVariant="h4" />
                    </Stack>

                    <Box>
                        <Formik onSubmit={handleFormSubmit} initialValues={initialValues} validationSchema={checkoutSchema}>
                            {({ values, errors, touched, handleBlur, handleChange, handleSubmit }) => (
                                <form onSubmit={handleSubmit}>
                                    <Grid container spacing={3}>
                                        <Grid item md={6} xs={12}>
                                            <Stack spacing={2}>
                                                <Stack direction="row">
                                                    <CssTextField
                                                        select
                                                        required
                                                        name="title"
                                                        onChange={handleChange}
                                                        value={values.title}
                                                        sx={{ width: 100 }}
                                                    >
                                                        {titles?.map((title, index) => (
                                                            <MenuItem value={title} key={index}>
                                                                {title}
                                                            </MenuItem>
                                                        ))}
                                                    </CssTextField>
                                                    <CssTextField
                                                        required
                                                        fullWidth
                                                        type="text"
                                                        // label="Name"
                                                        placeholder="Name *"
                                                        onBlur={handleBlur}
                                                        onChange={handleChange}
                                                        value={values.name}
                                                        name="name"
                                                        error={!!touched.name && !!errors.name}
                                                        helperText={touched.name && errors.name}
                                                        InputProps={{
                                                            startAdornment: (
                                                                <InputAdornment position="start">
                                                                    <Person />
                                                                </InputAdornment>
                                                            ),
                                                        }}
                                                    />
                                                </Stack>
                                                <CssTextField
                                                    // required={!agentEnabled}
                                                    fullWidth
                                                    type="email"
                                                    // label="Email"
                                                    placeholder={`Email`}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.email}
                                                    name="email"
                                                    error={!!touched.email && !!errors.email}
                                                    helperText={touched.email && errors.email}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Email />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                                <CssTextField
                                                    // required={!agentEnabled}
                                                    fullWidth
                                                    type="number"
                                                    placeholder={`Mobile`}
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.guestMobile}
                                                    name="guestMobile"
                                                    error={!!touched.guestMobile && !!errors.guestMobile}
                                                    helperText={touched.guestMobile && errors.guestMobile}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Phone />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                                <CssTextField
                                                    fullWidth
                                                    select
                                                    value={status}
                                                    label="Status"
                                                    onChange={(e) => setStatus(e.target.value)}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Build />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                >
                                                    <MenuItem value={"confirmed"}>
                                                        {"Confirmed"}
                                                    </MenuItem>
                                                    <MenuItem value={"hold"}>
                                                        {"Block"}
                                                    </MenuItem>
                                                </CssTextField>
                                                {/* <CssTextField
                                                    fullWidth
                                                    select
                                                    value={mealPlan}
                                                    label="Meal Plan"
                                                    onChange={(e) => setMealPlan(e.target.value)}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Restaurant />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                >
                                                    <MenuItem value={"no_preference"}>
                                                        {"Room Only"}
                                                    </MenuItem>
                                                    {mealPlans?.list?.map((e) => (
                                                        <MenuItem value={e?._id} key={e?._id}>
                                                            <Stack
                                                                width="100%"
                                                                direction="row"
                                                                justifyContent="space-between"
                                                                spacing={2}
                                                            >
                                                                <Typography>
                                                                    {e?.name?.toUpperCase()}
                                                                </Typography>
                                                                <Typography>
                                                                    ₹{e?.rate}
                                                                </Typography>
                                                            </Stack>
                                                        </MenuItem>
                                                    ))}
                                                </CssTextField> */}
                                                <CssTextField
                                                    fullWidth
                                                    type="number"
                                                    label="Paid Amount"
                                                    placeholder="Paid Amount"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.paidAmount}
                                                    name="paidAmount"
                                                    // onInvalid={e => e.target.setCustomValidity(rateErrorMsg)}
                                                    // onInput={e => e.target.setCustomValidity('')}
                                                    error={!!touched.paidAmount && !!errors.paidAmount}
                                                    helperText={touched.paidAmount && errors.paidAmount}
                                                    InputProps={{
                                                        inputProps: { min: 0, max: values.customPrice ?? rackRate },
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Money />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                                <CssTextField
                                                    fullWidth
                                                    type="number"
                                                    label="Special Price"
                                                    placeholder="Special Price"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.customPrice}
                                                    name="customPrice"
                                                    // error={!!touched.customPrice && !!errors.customPrice}
                                                    helperText={`Rack rate: ${rackRate}`}
                                                    InputProps={{
                                                        inputProps: { min: 0 },
                                                        startAdornment: (
                                                            <InputAdornment position="start">
                                                                <Money />
                                                            </InputAdornment>
                                                        ),
                                                    }}
                                                />
                                            </Stack>
                                        </Grid>
                                        <Grid item md={6} xs={12}>
                                            <Stack spacing={2}>
                                                <CssTextField
                                                    fullWidth
                                                    type="text"
                                                    label="Preference"
                                                    placeholder="Preference"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.preference}
                                                    name="preference"
                                                    error={!!touched.preference && !!errors.preference}
                                                    helperText={touched.preference && errors.preference}
                                                />
                                                <CssTextField
                                                    fullWidth
                                                    type="text"
                                                    label="Billing Instruction"
                                                    placeholder="Billing Instruction"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.billingInstruction}
                                                    name="billingInstruction"
                                                    error={!!touched.billingInstruction && !!errors.billingInstruction}
                                                    helperText={touched.billingInstruction && errors.billingInstruction}
                                                />
                                                <CssTextField
                                                    fullWidth
                                                    multiline
                                                    minRows={3}
                                                    maxRows={Infinity}
                                                    type="text"
                                                    size="small"
                                                    label="Address"
                                                    placeholder="Address"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.guestAddress}
                                                    name="guestAddress"
                                                    error={!!touched.guestAddress && !!errors.guestAddress}
                                                    helperText={touched.guestAddress && errors.guestAddress}
                                                />
                                                <CssTextField
                                                    fullWidth
                                                    multiline
                                                    minRows={3}
                                                    maxRows={Infinity}
                                                    type="text"
                                                    size="small"
                                                    label="Remarks"
                                                    placeholder="Remarks"
                                                    onBlur={handleBlur}
                                                    onChange={handleChange}
                                                    value={values.remarks}
                                                    name="remarks"
                                                    error={!!touched.remarks && !!errors.remarks}
                                                    helperText={touched.remarks && errors.remarks}
                                                />
                                                <Stack direction="row" alignItems="center">
                                                    <Typography noWrap>Agent booking</Typography>
                                                    <Switch
                                                        checked={agentEnabled}
                                                        onChange={(e) => setAgentEnabled(e.target.checked)}
                                                    />
                                                </Stack>
                                                {agentEnabled && (
                                                    <>
                                                        <Stack direction="row" spacing={1}>
                                                            <CssTextField
                                                                fullWidth
                                                                select
                                                                value={agent}
                                                                required={agentEnabled}
                                                                label="Agent / Agency"
                                                                onChange={handleAgentChange}
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <Person2 />
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            >
                                                                <MenuItem value={"no_preference"}>
                                                                    {"No selection"}
                                                                </MenuItem>
                                                                {agentsList?.map((agent) => (
                                                                    <MenuItem value={agent._id} key={agent._id}>
                                                                        {(agent?.first_name && `${agent?.first_name} ${agent?.last_name || ""}`) || agent?.email}
                                                                    </MenuItem>
                                                                ))}
                                                            </CssTextField>
                                                            <Button
                                                                variant="outlined"
                                                                color="primary"
                                                                title="Add new agent"
                                                                onClick={() => setAddAgentModal(true)}
                                                            >
                                                                <Add />
                                                            </Button>
                                                        </Stack>
                                                        <Stack direction="row" spacing={1}>
                                                            <CssTextField
                                                                fullWidth
                                                                select
                                                                value={subAgent}
                                                                required={agentEnabled}
                                                                label="Sub Agent"
                                                                onChange={(e) => setSubAgent(e.target.value)}
                                                                disabled={!agent || agent === "no_preference"}
                                                                InputProps={{
                                                                    startAdornment: (
                                                                        <InputAdornment position="start">
                                                                            <Person2 />
                                                                        </InputAdornment>
                                                                    ),
                                                                }}
                                                            >
                                                                <MenuItem value={"no_preference"}>
                                                                    {"No selection"}
                                                                </MenuItem>
                                                                {subAgentsList?.map((subagent) => (
                                                                    <MenuItem value={subagent._id} key={subagent._id}>
                                                                        {subagent?.name || ""}
                                                                    </MenuItem>
                                                                ))}
                                                            </CssTextField>
                                                            <Button
                                                                variant="outlined"
                                                                color="primary"
                                                                title="Add new sub agent"
                                                                onClick={() => setAddSubAgentModal(true)}
                                                                disabled={!agent || agent === "no_preference"}
                                                            >
                                                                <Add />
                                                            </Button>
                                                        </Stack>
                                                    </>
                                                )}
                                            </Stack>
                                        </Grid>
                                        {/* <Grid item md={6} xs={12}>
                                            <Stack spacing={2}>
                                                
                                            </Stack>
                                        </Grid> */}
                                    </Grid>

                                    <Grid container spacing={2} mt={1}>
                                        <Grid item md={12} xs={12}>
                                            <Stack direction="row" justifyContent="space-between">
                                                <Button
                                                    variant="outlined"
                                                    startIcon={<ArrowBack />}
                                                    onClick={() => setPage(2)}
                                                >
                                                    <b>Go back</b>
                                                </Button>
                                                <Button
                                                    type="submit"
                                                    variant="contained"
                                                    endIcon={<Done />}
                                                >
                                                    {isLoading ? <CircularProgress color="inherit" size={24} /> : <b>Book Now</b>}
                                                </Button>
                                            </Stack>
                                        </Grid>
                                    </Grid>
                                </form>
                            )}
                        </Formik>
                    </Box>
                </Grid>
            </Grid>

            <Modal
                open={addAgentModal}
                onClose={() => setAddAgentModal(false)}
            >
                <>
                    <AddNewAgentModalContent
                        dispatch={dispatch}
                        isLoading={isLoading}
                        setModal={setAddAgentModal}
                        setAgent={setAgent}
                        colors={colors}
                    />
                </>
            </Modal>

            <Modal
                open={addSubAgentModal}
                onClose={() => setAddSubAgentModal(false)}
            >
                <>
                    <AddNewSubAgentModalContent
                        id={agent}
                        dispatch={dispatch}
                        isLoading={isLoading}
                        setModal={setAddSubAgentModal}
                        setSubAgent={setSubAgent}
                        colors={colors}
                    />
                </>
            </Modal>
        </Box >
    );
};

export default AddNewBooking;